import { render, staticRenderFns } from "./RevisionItemView.vue?vue&type=template&id=46d0f666&"
import script from "./RevisionItemView.vue?vue&type=script&lang=ts&"
export * from "./RevisionItemView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports